(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

	// Scroll velocity and direction tracking
(function () {
  let lastScrollTop = 0;
  let lastScrollTime = Date.now();
  let scrollVelocity = 0;
  let scrollDirection = 'none';
	let scrollThreshold = 20;

  // Function to calculate scroll velocity (pixels per second)
  function calculateScrollVelocity(currentScrollTop) {
    const currentTime = Date.now();
    const timeDiff = currentTime - lastScrollTime;
    const scrollDiff = currentScrollTop - lastScrollTop;

    // Calculate velocity in pixels per second
    scrollVelocity = (scrollDiff / timeDiff) * 1000;

    // Update direction
    scrollDirection = scrollDiff > 0 ? 'down' : scrollDiff < 0 ? 'up' : 'none';

    // Update last values
    lastScrollTop = currentScrollTop;
    lastScrollTime = currentTime;

    // Log the values
    return {
      velocity: Math.round(scrollVelocity * 100) / 100, // Round to 2 decimal places
      direction: scrollDirection,
      scrollPosition: currentScrollTop,
    }
  }

	  // Function to calculate scroll velocity (pixels per second)
		function showHideHeader(currentScrollTop) {
    const velocity = currentScrollTop?.velocity;
    const direction = currentScrollTop?.direction;
    const scrollPosition = currentScrollTop?.scrollPosition;


		if (direction === 'up') {
			document.querySelector('sticky-header header.header').classList.add('unminimized');
		} else {
			document.querySelector('sticky-header header.header').classList.remove('unminimized');
		}
		if (currentScrollTop.scrollPosition < scrollThreshold) {
			document.querySelector('sticky-header header.header').classList.add('init');
			document.querySelector('sticky-header header.header').classList.remove('unminimized');
		} else {
			document.querySelector('sticky-header header.header').classList.remove('init');
		}

  }

  // Throttle function to limit how often we calculate velocity
  function throttle(func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  // Add scroll event listener with throttling
  window.addEventListener(
    'scroll',
    throttle(() => {
      showHideHeader(calculateScrollVelocity(window.pageYOffset));
    }, 16),
  ); // ~60fps
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function tryPlay(video) {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('active');
      document.querySelector('.product-features-modals').classList.remove('active');
      var video = modal.querySelector('video');
      if (video) {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }
    }

    const modalCloseButtons = document.querySelectorAll('.product-features-modal-close');
    modalCloseButtons.forEach((button) => {
      button.addEventListener('click', function () {
        closeModal(this.closest('.product-features-modal'));
      });
    });

    const modalBackgrounds = document.querySelectorAll('.product-features-modals');
    modalBackgrounds.forEach((background) => {
      background.addEventListener('click', function () {
        closeModal(document.querySelector('.product-features-modal.active'));
      });
    });

    const modalOpenButtons = document.querySelectorAll('.feature-toggle');
    modalOpenButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const title = button.dataset.title;
        const modal = document.querySelector(`.product-features-modal[data-title="${title}"]`);
        if (!modal) return;
        modal.classList.add('active');
        document.querySelector('.product-features-modals').classList.add('active');

        const tpl = modal.querySelector('.product-features-modal-video-tpl');
        if (tpl && !modal.querySelector('video')) {
          tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
        }

        var video = modal.querySelector('video');
        if (video) {
          video.muted = true;
          if (video.readyState >= 2) {
            tryPlay(video);
          } else {
            video.addEventListener('loadedmetadata', function () { tryPlay(video); }, { once: true });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
